import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

/* -------------- */
/*    QUESTIONNAIRE    */
/* -------------- */
export const FIND_RISK_SCORES = 'FIND_RISK_SCORES';
export const FIND_RISK_SCORE_SET_BY_ID = 'FIND_RISK_SCORE_SET_BY_ID';

export const riskScoreApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const useRiskScoreApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...riskScoreApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling questionnaire api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
